(function() {
	document.addEventListener("DOMContentLoaded", function() {

		// form on the Edit Car page
		if(document.getElementById("steps-uid-0")) {
			var editPhotoGallery = document.getElementById("editPhotoGallery");
			
			if(editPhotoGallery) {
				let oldList = document.getElementsByClassName("file-preview_old")[0];

				// if you have previously downloaded photos
				if(oldList) {
					let images = oldList.getElementsByClassName("file-preview__image");

					for(let i = 0; i < images.length; i++) {
						if(images[i].dataset.main == 1) {
							images[i].parentElement.querySelector("input[type='radio']").setAttribute("checked", true);
							break;
						}
					}
				} 

				// only radio...
				editPhotoGallery.addEventListener("click", function(event) {
					event = event || window.event;

					var target = event.target;
					var regName = /status_photos/;

					if(target.type === "radio" && regName.test(target.name)) {
						let radios = this.querySelectorAll("input[name^=status_photos][type=radio]");

						for(let j = 0; j < radios.length; j++) {
							radios[j].removeAttribute("checked");
							radios[j].checked = false;
						}

						target.setAttribute("checked", true);
						target.checked = true;
					}
				});
			}
		}
		
	});
})();